module.exports = __webpack_public_path__ + "img/promo-febrero-1-ertiga-2021.40b1f5c4.jpg";